import { Box } from '@chakra-ui/react'
import {
  faAward,
  faFire,
  faHandPointRight,
  faPersonRunning,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function getSeriesStreakStatusConfig({
  hasUpcomingSessions,
  currentStreak,
  longestStreak,
}: {
  hasUpcomingSessions: boolean
  currentStreak: number
  longestStreak: number
}) {
  const primaryText = hasUpcomingSessions
    ? currentStreak >= 2
      ? "You're Unstoppable!"
      : currentStreak > 0
        ? 'Keep Going!'
        : 'Start Your Streak!'
    : longestStreak >= 2
      ? `${longestStreak} session streak`
      : 'Next time, aim for a streak!'

  const secondaryText = hasUpcomingSessions
    ? currentStreak > 1
      ? `${currentStreak} session streak`
      : null
    : longestStreak >= 2
      ? 'Longest streak'
      : null

  const iconComponent = hasUpcomingSessions ? (
    currentStreak >= 2 ? (
      <>
        <Box
          position="absolute"
          top="15px"
          left="8px"
          width="20px"
          height="20px"
          borderRadius="50%"
          bg="error.solid"
          zIndex="0"
        />
        <Box position="relative" zIndex="1">
          <FontAwesomeIcon icon={faFire} color={chakraTokenToVar('yellow.solid')} />
        </Box>
      </>
    ) : (
      <FontAwesomeIcon icon={faPersonRunning} color={chakraTokenToVar('fg.subtle')} />
    )
  ) : longestStreak >= 2 ? (
    <FontAwesomeIcon icon={faAward} color={chakraTokenToVar('blue.fg')} />
  ) : (
    <FontAwesomeIcon icon={faHandPointRight} color={chakraTokenToVar('fg.subtle')} />
  )

  return {
    primaryText,
    secondaryText,
    iconComponent,
  }
}
